export const TYING_TETHER = 'tyingTether'
